module.exports = __webpack_public_path__ + "static/Radiology-Augmentation-901872f5d1d3919e7f6e103f50c45684.jpg";